import { render, staticRenderFns } from "./SupplyDetails.vue?vue&type=template&id=bbd2f7d8&scoped=true&"
import script from "./SupplyDetails.vue?vue&type=script&lang=js&"
export * from "./SupplyDetails.vue?vue&type=script&lang=js&"
import style0 from "./SupplyDetails.vue?vue&type=style&index=0&id=bbd2f7d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd2f7d8",
  null
  
)

export default component.exports